import Utils from '../../../utils'
import AvatarCropper from 'vue-avatar-cropper'

export default {
  name: 'ImageSelectCropper',
  components: { AvatarCropper },
  props: {
    idImage: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    fontsize: {
      default: 16,
      type: Number,
      required: false
    },
    borderradius: {
      default: 0,
      type: Number,
      required: false
    },
    context: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      image: null,
      dragImage: null,
      displayCropperCircular: false,
      displayCropperRectangle: false,
      filename: ''
    }
  },
  async created() {
    this.image = this.source()
  },
  methods: {
    handleCropperEvent(cropper) {
      // cropper.js
      const base64Image = cropper.getCroppedCanvas().toDataURL('image/png')
      this.image = base64Image
      this.$emit('changeImage', {
        filename: this.filename,
        data: base64Image
      })
    },
    openCropper() {
      this.displayCropperCircular = this.borderradius !== 0
      this.displayCropperRectangle = this.borderradius === 0
    },
    async onFileChange({ file }) {
      this.filename = file.name || 'avatar'
    },
    onRemove() {
      this.image = null
      this.$emit('removeImage', {})
    },
    source() {
      const image = this.$store.getters.image(this.idImage)
      return Utils.validBase64SrcString(image)
    },
    onDrop(event) {
      this.dragImage = event.dataTransfer.files[0]
      this.openCropper()
    }
  },
  computed: {
    cropperOptions() {
      return {
        aspectRatio: this.width / this.height,
        autoCropArea: 1,
        viewMode: 1,
        movable: false,
        zoomable: false
      }
    }
  }
}
